import styled from 'styled-components';

export default styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  margin-top: 46px;

  .foreground-area {
    display: none;
    z-index: 300;

    @media (max-width: 1115px) {
      display: flow;
    }
  }

  .filters-area {
    justify-content: space-between;
  }
`;

export const InputBox = styled.div`
  display: grid;
  /* grid-template-rows: repeat(3, max-content); */
  width: 100%;
  margin-bottom: 25px;
  
  h3 {
    /* font-weight: 700; */
    font-size: 18px;
    line-height: 24.52px;
    margin-bottom: 8px;
    color: ${({ theme }) => theme.mainTheme.color.gray50};
  }
`;
